import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { InputMask } from '../../../../../CommonComponents/OPL/Input/InputMask';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { StepCard } from '../../StepCard/StepCard';

export const BIRTH_DATE = 'birthDate';

export interface BirthdateFormField {
  [BIRTH_DATE]?: string;
}

export const YourDateOfBirth = () => {
  const {
    formState: { errors },
    register,
  } = useFormContext<BirthdateFormField>();

  return (
    <StepCard>
      <Text color="neutral.700" fontSize="h3" fontWeight={500}>
        When is your birthday?
      </Text>
      <Text color="neutral.500" mt="8">
        Your age and time until retirement are key factors in assessing your risk tolerance
      </Text>

      <Box display="flex" mt="32">
        <InputMask
          aria-label="Your birthdate"
          autoComplete="bday"
          formVariant={errors[BIRTH_DATE] ? 'error' : undefined}
          helperText={errors[BIRTH_DATE]?.message}
          label="Your birthdate"
          leftIcon="far fa-calendar-alt"
          mask="99/99/9999"
          maskPlaceholder={null}
          placeholder="MM/DD/YYYY"
          {...register(BIRTH_DATE)}
          type="text"
        />
      </Box>
    </StepCard>
  );
};
